import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/.pnpm/@vercel+analytics@1.4.1_next@15.2.0-canary.23_@babel+core@7.24.5_@opentelemetry+api@1.9.0_bab_s5di3phbfwqpcv2oeufcp7twr4/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.0-canary.23_@babel+core@7.24.5_@opentelemetry+api@1.9.0_babel-plugin-react-compiler_b5xqfpo7gijlklyonndxb3bgyy/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["IntlClientProvider"] */ "/vercel/path0/src/i18n/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/src/ui/shadcn/sonner.tsx");
